<template>
  <Content class="all_news-content">
    <div class="all-news-svg" />
    <Card class="all_news" dis-hover>
      <h1 slot="title">{{$t('all_news')}}</h1>
      <div class="loading apollo" v-if="$apollo.queries.BankNews.loading">
        <Spin fix>
          <Icon type="ios-loading" size="18" class="icon-load"></Icon>
          <div>{{$t('loading')}}</div>
        </Spin>
      </div>

      <!-- Error -->
      <div v-else-if="error" class="error apollo">{{$t('error')}}</div>
      <div v-else-if="!bankNews.length" class="empty-wrapper">
        <Empty />
      </div>
      <!-- Result -->
      <Row v-else-if="bankNews" class="result apollo" :gutter="15">
        <news-item
          v-for="(item, index) in bankNews"
          :key="index"
          :title="item.title"
          :title_al="item.title_al"
          :src="item.image.url"
          :description="item.description"
          :description_al="item.description_al"
          :id="item.id"
          style="padding-left: 7.5px; padding-right: 7.5px;"
        />
      </Row>
      <div v-else class="no-result apollo">{{$t('no_result')}}</div>
    </Card>
  </Content>
</template>
<script>
import NewsItem from '../components/NewsItem.vue';
import BankNews from '../graphql/News.gql';
import Empty from '../components/Empty.vue';

export default {
  components: {
    NewsItem,
    Empty,
  },
  data() {
    return {
      bankNews: null,
      error: null,
    };
  },
  apollo: {
    BankNews: {
      query: BankNews,
      variables() {
        const query = {
          where: {
            [this._i18n === 'en' ? 'title_contains' : 'title_al_contains']: this
              .$router.history.current.query.title,
          },
        };
        return query;
      },
      result({ data: { banknews }, error }) {
        this.bankNews = banknews;
        this.erorr = error;
      },
      update({ banknews }) {
        return banknews;
      },
    },
  },
};
</script>
<style lang="scss">
.all_news-content {
  .empty-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .all-news-svg {
    background-image: url("../assets/undraw_news_go0e.svg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    max-height: 401px;
    margin: 20px 0;
    height: 100%;
    min-height: 400px;
    width: 100%;
  }
  margin: 15px 0;
  .all_news {
    // .ivu-card-head,
    // .ivu-card-body {
    //   padding: 28px 32px;
    // }
    .loading.apollo {
      min-height: 500px;
      position: relative;
    }

    .card-column {
      margin-bottom: 20px;
    }
    min-height: 500px;
  }
}
// @media only screen and (max-width: 576px) {
//   .all-news-content {
//     .all-news {
//       .ivu-card-head,
//       .ivu-card-body {
//         padding: 22px 26px;
//       }
//     }
//   }
// }
</style>
